<template>
  <div>
    <v-dialog
      v-model="dialog"
      width="800"
      scrollable
      persistent
    >
      <v-card>
        <v-card-title>
          <v-btn icon class="ml-n3 mr-3" @click="fecharDialog()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          Atualizações do Sistema
          <v-spacer></v-spacer>
          <span style="font-size: 15px">Versão: {{app_version}}</span>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="pa-0 px-5 mt-4">
          <p v-if="releaseAtual.id" style="text-align: justify" v-html="releaseAtual.descricao"></p>

          <p v-else>Nenhum dado encontrado.</p>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn text @click="fecharDialog()">
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ReleasesNotesAPI from "../../../api/releasesNotes";

export default {
  model: {
    prop: 'dialog',
    event: 'change-dialog'
  },
  props: {
    dialog: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      app_version: localStorage.getItem('app_version'),
      releaseAtual: {
        id: '',
        versao: '',
        descricao: ''
      },
    }
  },
  watch: {
    dialog () {
      if (this.dialog) {
        this.buscarUltimaVersao()
      }
    }
  },
  methods: {
    buscarUltimaVersao() {
      const headers = this.Helpers.iniciarRequisicao();

      const params = { versao: localStorage.getItem('app_version') }

      this.$store.dispatch(
        "loading/addRequisicao",
        ReleasesNotesAPI.buscarUltimaVersao(headers, params)
          .then((response) => {
            const {releaseAtual, token} = response.data;
            localStorage.setItem("token", token);
            this.releaseAtual = releaseAtual;
          })
          .catch(() => {
            this.Helpers.logout();
          })
      );
    },
    fecharDialog () {
      this.$emit('change-dialog', false)
    }
  }
}
</script>
